import { render, staticRenderFns } from "./campaignCopyButton.vue?vue&type=template&id=42108ac9&scoped=true&"
import script from "./campaignCopyButton.vue?vue&type=script&lang=js&"
export * from "./campaignCopyButton.vue?vue&type=script&lang=js&"
import style0 from "./campaignCopyButton.vue?vue&type=style&index=0&id=42108ac9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42108ac9",
  null
  
)

export default component.exports